namespace GeniuzPOS.Inventory {
    export interface IcStockSoldDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        QtyUse?: number;
        UseFg?: number;
    }

    export namespace IcStockSoldDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockSoldDt';
        export const lookupKey = 'Inventory.IcStockSoldDt';

        export function getLookup(): Q.Lookup<IcStockSoldDtRow> {
            return Q.getLookup<IcStockSoldDtRow>('Inventory.IcStockSoldDt');
        }
        export const deletePermission = '2Inventory:รายการ:เบิกขาย:Modify';
        export const insertPermission = '2Inventory:รายการ:เบิกขาย:Modify';
        export const readPermission = '2Inventory:รายการ:เบิกขาย:View';
        export const updatePermission = '2Inventory:รายการ:เบิกขาย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            QtyUse = "QtyUse",
            UseFg = "UseFg"
        }
    }
}
